import React from 'react';
import orcamentoImg from '@/assets/95c03676-492c-4c3f-b504-c5b8e1fd0068.webp';
import Navbar from '@/pages/Navbar/Navbar';
import Rodape from '@/pages/Rodape/Rodape';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Tilt from 'react-parallax-tilt';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import antes1 from '@/assets/antes1.jpg';
import depois1 from '@/assets/depois1.jpg';
import antes2 from '@/assets/antes2.jpg';
import depois2 from '@/assets/depois2.jpg';
import { motion } from "framer-motion";
import antes3 from '@/assets/antes3.jpg';
import depois3 from '@/assets/depois3.jpg';
import { useState } from 'react';



const servicos = [
  { antes: antes1, depois: depois1 },
  { antes: antes2, depois: depois2 },
  { antes: antes3, depois: depois3 },
];

const imageVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" },
  }),
};

export default function Home() {
  const [modalImg, setModalImg] = useState(null);
  return (
    <>
      <Navbar />
      <main className="text-gray-800 font-sans relative z-0">
        {/* Sessão 1: Boas-vindas estilo Master Clean */}
        <section className="w-full bg-white py-24 px-6">
          <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-12">
            <div className="md:w-1/2 animate-fade-in-up">
<h2
  className="text-[22px] font-[500] text-[#3b2e2e] mb-6"
  style={{ fontFamily: "'Montserrat', sans-serif" }}
>
  SEJA BEM VINDO
</h2>

<p className="text-gray-800 mb-4 leading-relaxed text-justify">
  Seja muito bem-vindo à <strong>Prime Higienizações</strong>, uma empresa comprometida com a excelência na higienização profunda de estofados em ambientes corporativos ou residenciais. Utilizamos tecnologia de ponta e técnicas modernas para garantir um resultado impecável e seguro para sua família ou negócio.
</p>
<p className="text-gray-800 mb-6 leading-relaxed text-justify">
  Reconhecida pela confiança, agilidade e atendimento personalizado, a <strong>Prime Higienizações</strong> é referência no Vale do Aço por transformar ambientes com qualidade e responsabilidade. Aqui, seu conforto e bem-estar são prioridade em cada serviço realizado.
</p>
<a
  href="/sobre"
  className="inline-block px-6 py-3 text-[#3b2e2e] border-2 border-[#3b2e2e] rounded-full font-semibold hover:bg-[#3b2e2e] hover:text-white transition duration-300"
>
  Saiba Mais
</a>

            </div>
<div className="relative w-full md:w-1/2 md:h-[400px] flex md:flex-row items-center justify-center animate-fade-in-up">

  {/* Imagem 1 */}
  <motion.div
    className="absolute md:static top-0 left-6 w-36 md:w-44 aspect-[4/3] shadow-xl rounded-lg overflow-hidden border-4 border-[#C9AA7B] ring-1 ring-black/10 rotate-[-3deg] z-30"
    custom={0}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
    variants={imageVariants}
  >
    <img src="/img1.png" alt="Serviço 1" className="w-full h-full object-cover" />
  </motion.div>

  {/* Imagem 2 - deslocada mais para a direita */}
  <motion.div
    className="absolute md:static top-6 left-30 w-36 md:w-44 aspect-[4/3] shadow-xl rounded-lg overflow-hidden border-4 border-[#C9AA7B] ring-1 ring-black/10 rotate-[2deg] z-20"
    custom={1}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
    variants={imageVariants}
  >
    <img src="/img2.png" alt="Serviço 2" className="w-full h-full object-cover" />
  </motion.div>

  {/* Imagem 3 - ainda mais à direita */}
  <motion.div
    className="absolute md:static top-12 left-60 w-36 md:w-44 aspect-[4/3] shadow-xl rounded-lg overflow-hidden border-4 border-[#C9AA7B] ring-1 ring-black/10 rotate-[-1deg] z-10"
    custom={2}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
    variants={imageVariants}
  >
    <img src="/img3.png" alt="Serviço 3" className="w-full h-full object-cover" />
  </motion.div>

</div>




          </div>
        </section>

        {/* Sessão 3: Nossos Serviços */}
        <section className="bg-gradient-to-b from-[#f5f1ef] to-white py-20 px-4">
<h2
  className="text-center text-[28px] md:text-[40px] font-[700] text-[#3b2e2e] mb-6 animate-fade-in-down drop-shadow-lg flex flex-col md:flex-row items-center justify-center gap-2"
  style={{ fontFamily: "'Montserrat', sans-serif" }}
>
  <span>SERVIÇOS REALIZADOS</span>
  <a
    href="/fotos"
    className="text-[#c9aa7b] text-[16px] md:text-[18px] font-medium underline hover:text-[#b8936a] transition-colors duration-300"
  >
    – Para mais, clique aqui
  </a>
</h2>


           <div className="w-24 h-1 mx-auto mb-12 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 rounded-full animate-fade-in"></div>

          <div className="max-w-7xl mx-auto relative">
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              navigation={{
                nextEl: '.custom-next',
                prevEl: '.custom-prev',
              }}
              pagination={{ el: '.swiper-pagination', clickable: true }}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              className="relative"
            >
              {servicos.map((item, index) => (
                <SwiperSlide key={index}>
                  <Tilt tiltMaxAngleX={10} tiltMaxAngleY={10} glareEnable={true} glareMaxOpacity={0.3} glareColor="#ffffff" glarePosition="all">
                    <div className="flex flex-row gap-3 items-start p-4 bg-white/80 backdrop-blur-md rounded-xl shadow-2xl hover:shadow-3xl transition-shadow duration-300">
                      {/* Antes */}
                      <div className="relative w-1/2 overflow-hidden rounded-lg transform hover:scale-105 transition-transform duration-300">
                        <img src={item.antes} alt="Antes" className="w-full h-64 object-cover" />
                        <span className="absolute bottom-3 left-3 bg-gradient-to-r from-gray-800 to-gray-900 text-white text-xs font-semibold px-3 py-1 rounded-md shadow-md">
                          ANTES
                        </span>
                        <span className="absolute top-3 right-3 bg-gradient-to-r from-[#C9AA7B] to-[#C9AA7B]-200 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm">
                          PH
                        </span>
                      </div>
                      {/* Depois */}
                      <div className="relative w-1/2 overflow-hidden rounded-lg transform hover:scale-105 transition-transform duration-300">
                        <img src={item.depois} alt="Depois" className="w-full h-64 object-cover" />
                        <span className="absolute bottom-3 left-3 bg-gradient-to-r from-gray-800 to-gray-900 text-white text-xs font-semibold px-3 py-1 rounded-md shadow-md">
                          DEPOIS
                        </span>
                        <span className="absolute top-3 right-3 bg-gradient-to-r from-[#C9AA7B] to-[#C9AA7B]-200 text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm">
                          PH
                        </span>
                      </div>
                    </div>
                  </Tilt>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Botões personalizados */}
            <div className="absolute bottom-4 right-4 z-20 flex gap-3">
              <button className="custom-prev w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[#C9AA7B] to-[#C9AA7B]-800 text-white rounded-full shadow-lg hover:shadow-xl hover:bg-gradient-to-r hover:from-[#C9AA7B]-600 hover:to-[#c9aa7b] transition-all duration-300 transform hover:scale-110">
                <span className="text-xl font-bold">{'<'}</span>
              </button>
              <button className="custom-next w-12 h-12 flex items-center justify-center bg-gradient-to-r from-[#C9AA7B] to-[#C9AA7B]-800 text-white rounded-full shadow-lg hover:shadow-xl hover:bg-gradient-to-r hover:from-[#C9AA7B]-600 hover:to-[#a8805a] transition-all duration-300 transform hover:scale-110">
                <span className="text-xl font-bold">{'>'}</span>
              </button>
            </div>

            {/* Paginação */}
            <div className="swiper-pagination mt-8"></div>
          </div>

          <div className="text-center mt-12">
<a
  href="https://wa.me/5531993127020?text=Olá,%20estou%20vindo%20do%20site%20e%20gostaria%20de%20fazer%20um%20orçamento"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block bg-gradient-to-r from-[#C9AA7B] to-[#b8936a] hover:from-[#b8936a] hover:to-[#a8805a] text-white font-bold py-4 px-10 rounded-full transition duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 animate-pulse-scale"
>
  SOLICITE AQUI AGORA!
</a>

          </div>

          {/* Estilo das bolinhas de paginação e animações */}
          <style>{`
            .swiper-pagination {
              margin-top: 2rem;
              text-align: center;
              position: relative;
              z-index: 10;
            }
            .swiper-pagination-bullet {
              width: 10px;
              height: 10px;
              background-color: #d1d5db;
              opacity: 1;
              border-radius: 9999px;
              margin: 0 8px !important;
              transition: all 0.3s ease;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            }
            .swiper-pagination-bullet-active {
              background: linear-gradient(to right, #3b82f6, #1d4ed8);
              width: 14px;
              height: 14px;
              transform: scale(1.3);
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
            }
            .shadow-3xl {
              box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
            }
            @keyframes pulseScale {
              0% { transform: scale(1); }
              50% { transform: scale(1.05); }
              100% { transform: scale(1); }
            }
            .animate-pulse-scale {
              animation: pulseScale 2s infinite ease-in-out;
            }
            @keyframes fadeInDown {
              from { opacity: 0; transform: translateY(-20px); }
              to { opacity: 1; transform: translateY(0); }
            }
            .animate-fade-in-down {
              animation: fadeInDown 0.8s ease-out;
            }
          `}</style>
        </section>

        {/* Sessão 4: Solicite um Orçamento */}
        <section
          id="orcamento"
          className="relative text-white text-center py-24 px-4"
          style={{
            backgroundImage: `url(${orcamentoImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="absolute inset-0 bg-black/70"></div>
          <div className="relative max-w-4xl mx-auto animate-fade-in">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Solicite um Orçamento
            </h2>
<p className="mb-8 max-w-2xl mx-auto text-lg">
  Contamos com uma equipe especializada e preparada para oferecer serviços com alto padrão de qualidade, utilizando equipamentos modernos e técnicas eficazes que garantem resultados superiores em cada atendimento.
</p>

<a
  href="https://wa.me/5531993127020?text=Olá,%20estou%20vindo%20do%20site%20e%20gostaria%20de%20fazer%20um%20orçamento"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-block bg-[#C9AA7B] hover:bg-[#b8936a] text-white font-bold py-3 px-8 rounded-full transition duration-300"
>
  ORÇAMENTO GRÁTIS
</a>


          </div>
        </section>

        {/* Sessão 5: Opinião de Clientes */}
        <section className="bg-white py-16 px-4">
  <h2
    className="text-center font-[500] text-[30px] text-gray-800 mb-4 animate-fade-in"
    style={{ fontFamily: "'Montserrat', sans-serif" }}
  >
    FEEDBACK
  </h2>
  <div className="w-24 h-1 mx-auto mb-12 bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600 rounded-full animate-fade-in"></div>
  <div className="max-w-6xl mx-auto">
    <Swiper
      modules={[Pagination]}
      pagination={{ clickable: true }}
      slidesPerView={1}
      breakpoints={{
        768: { slidesPerView: 2 },
      }}
    >
      {[
        { author: "Angelica", img: "/angelica.jpg" },
        { author: "Larissa", img: "/larissa.jpg" },
        { author: "Israel", img: "/israel.jpg" },
      ].map((testimonial, index) => (
        <SwiperSlide key={index}>
          <div className="bg-white rounded-lg p-6 flex flex-col items-center gap-4 mx-4 shadow-lg">
            <h3 className="text-lg font-semibold text-gray-900 text-center">
              {testimonial.author}
            </h3>
            <div className="text-yellow-500 mb-2">★★★★★</div>
            <button onClick={() => setModalImg(testimonial.img)}>
              <img
                src={testimonial.img}
                alt={`Feedback de ${testimonial.author}`}
                className="rounded-lg object-cover w-full max-w-xs border border-gray-300 hover:scale-105 transition-transform duration-200"
              />
            </button>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>

    {/* Modal de imagem */}
    {modalImg && (
      <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
        <div className="relative">
<button
  onClick={() => setModalImg(null)}
  className="absolute top-2 right-2 w-10 h-10 flex items-center justify-center text-yellow-400 text-2xl font-bold bg-white rounded-full hover:text-yellow-600 hover:bg-yellow-100 transition shadow-lg"
>
  &times;
</button>
          <img
            src={modalImg}
            alt="Imagem ampliada"
            className="max-h-[90vh] max-w-[90vw] rounded-lg border-4 border-white shadow-2xl"
          />
        </div>
      </div>
    )}

    <div className="mt-12 text-center">
      <div className="swiper-pagination"></div>
    </div>
    <style>{`
      .swiper-pagination {
        position: relative !important;
        bottom: 0 !important;
        margin-top: 2rem !important;
      }
      .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
        border-radius: 9999px;
        background: white;
        border: 2px solid #000;
        margin: 0 6px !important;
        opacity: 1;
        transition: all 0.3s ease;
      }
      .swiper-pagination-bullet-active {
        background: linear-gradient(to right, #facc15, #fbbf24, #f59e0b);
        transform: scale(1.2);
        border-color: #000;
      }
    `}</style>
  </div>
</section>
      </main>
      <Rodape />
      <style>{`
        @keyframes fadeInDown {
          from { opacity: 0; transform: translateY(-20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-down {
          animation: fadeInDown 0.8s ease-out;
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.8s ease-out;
        }
        .animate-fade-in {
          animation: fadeInUp 1s ease-out;
        }
      `}</style>
    </>
  );
}